(function() { window.GUID_3c287f7a_a7c0_46dc_b3c2_72bbd76f23a2 = { getGuid: function() { return "3c287f7a-a7c0-46dc-b3c2-72bbd76f23a2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScriptErrorLogger {
            constructor() {
            }
            static get Instance() {
                if (!ScriptErrorLogger.instance) {
                    ScriptErrorLogger.instance = new ScriptErrorLogger();
                }
                return ScriptErrorLogger.instance;
            }
            LogError() {
                try {
                    // handled errors
                    const originalConsoleError = console.error;
                    console.error = (msg) => {
                        originalConsoleError(msg);
                        let errorMessage = "Handled script error in a 'try catch' : " + msg;
                        if (!errorMessage.includes("Standalone bad response. Status; 400 Response:")) {
                            this.showAndSaveErrors(errorMessage);
                        }
                    };
                    // unhandled errors
                    window.onerror = (msg) => {
                        let errorMessage = "Unhandled script error : " + msg;
                        this.showAndSaveErrors(errorMessage);
                    };
                }
                catch (error) {
                    console.error("Error while binding to ScriptErrorLogger", error);
                }
            }
            showAndSaveErrors(errorMessage) {
                var buffer = 1;
                if (!ScriptErrorStatic.Instance.errors.find(index => index == errorMessage))
                    ScriptErrorStatic.Instance.errors.push(errorMessage);
                let $scriptError = $('#scriptError');
                if ($scriptError.length == 0) {
                    $('#MasterContainer').append(`<div id="scriptError"></div>`);
                    $scriptError = $('#scriptError');
                    $scriptError.css({
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        backgroundColor: "red",
                        color: "black",
                        margin: "0.1em"
                    });
                    $scriptError.offon("click.removeErrorMessage", ".script-error-message", function () {
                        try {
                            $(this).remove();
                        }
                        catch (error) {
                            console.error("Error while removing script error message", error);
                        }
                    });
                }
                let divErrorsCount = $('.script-error-message', $scriptError).length;
                if (divErrorsCount < buffer) {
                    $scriptError[0].innerHTML += `<div class="script-error-message" >${errorMessage} </div>`;
                }
                if ($('#numberOfScriptError').length == 0)
                    $('#scriptError').append(`<div id="numberOfScriptError"></div>`);
                $('#numberOfScriptError')[0].innerHTML = `<div class="script-error-message" >Number of different errors : ${ScriptErrorStatic.Instance.errors.length} </div>`;
            }
        }
        Controls.ScriptErrorLogger = ScriptErrorLogger;
        class ScriptErrorStatic {
            constructor() {
                this.errors = [];
            }
            static get Instance() {
                if (!ScriptErrorStatic.instance) {
                    ScriptErrorStatic.instance = new ScriptErrorStatic();
                }
                return ScriptErrorStatic.instance;
            }
        }
        Controls.ScriptErrorStatic = ScriptErrorStatic;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs.scripterrorlogger.js.map
